// Display-only rules: retain stored recovery timestamps for audit/workflow history.
const time = value => value == null || value === "" ? NaN : new Date(value).getTime();
export function isSyntheticBayGate(movement) {
    return String(movement?.checkpointType || "").toLowerCase() === "gatein"
        && (["BAY_MINUS_5_MIN", "BAY_ARRIVAL_TIME"].includes(movement.backfill?.reason)
            || (movement.hideFromUi === true && !movement.backfill?.reason));
}
export function tripDisplayStart(movements = []) {
    const observed = movements.filter(movement => !isSyntheticBayGate(movement))
        .map(movement => time(movement.inTime)).filter(Number.isFinite);
    return observed.length ? Math.min(...observed) : null;
}
export function recentDisplayTurnaround(row) {
    if (!row.gateInHidden || row.queueInAt) return row.turnaroundMs;
    const start = time(row.firstBayInAt), end = time(row.gateOutAt);
    return Number.isFinite(start) && Number.isFinite(end) ? Math.max(0, end - start) : row.turnaroundMs;
}
